import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { joinOrganization, unsetOrganization } from "../../../../api";
import { Box } from "@mui/material";
import Fab from "@mui/material/Fab";
import ConnectedTable from "./ConnectedTable";
import DisconnectedTable from "./DisconnectedTable";
import SnackbarCustom, {
  type SnackbarData,
} from "../../../../components/SnackBarCustom";
import type { OrganizationIdsState } from "./organizationTableTypes";

export default function Connecting() {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };
  const searchParams = new URLSearchParams(useLocation().search);
  const roleId = searchParams.get("role-id");

  const [update, setUpdate] = useState<boolean | string | undefined>();
  const handleChangeData = () => {
    setUpdate(update === true ? false : true);
  };

  const [connectedOrganizations, setConnectedOrganizations] =
    useState<OrganizationIdsState>({
      m_organization_ids: null,
    });

  const [disconnectedOrganizations, setDisconnectedOrganizations] =
    useState<OrganizationIdsState>({
      m_organization_ids: null,
    });

  const [snackBarstatus, setSnackBarstatus] = useState<SnackbarData>();
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const splitOrganization = async () => {
    try {
      const status = await unsetOrganization({
        m_organization_ids: connectedOrganizations.m_organization_ids,
      });
      console.log("関連解除完了", status);
      setSnackBarstatus(status);
      setSnackbarOpen(true);
      handleChangeData();
    } catch (error) {
      console.error("API呼び出しエラー", error);
    }
  };

  const connectOrganization = async () => {
    try {
      const status = await joinOrganization({
        m_organization_ids: disconnectedOrganizations.m_organization_ids,
        m_role_id: Number(roleId) || 0,
      });
      console.log("関連付け完了", status);
      setSnackBarstatus(status);
      setSnackbarOpen(true);
      handleChangeData();
    } catch (error) {
      console.error("API呼び出しエラー", error);
    }
  };

  const ClickRegistration = () => {
    if (connectedOrganizations.m_organization_ids !== null) {
      void splitOrganization();
      setUpdate("split");
    }
    if (disconnectedOrganizations.m_organization_ids !== null) {
      void connectOrganization();
      setUpdate("join");
    }
    setConnectedOrganizations({
      m_organization_ids: null,
    });
    setDisconnectedOrganizations({
      m_organization_ids: null,
    });
  };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Box
          onClick={handleGoBack}
          sx={{
            display: "flex",
            height: "48px",
            alignItems: "center",
            paddingLeft: "40px",
            fontSize: 20,
            fontWeight: "bold",
            whiteSpace: "nowrap",
            color: "primary.main",
            cursor: "pointer",
            textDecoration: "underline",
            "&:hover": {
              color: "primary.dark",
            },
            "&:active": {
              color: "primary.light",
            },
          }}
        >
          権限設定
        </Box>
        <Box
          sx={{
            display: "flex",
            height: "48px",
            alignItems: "center",
            fontSize: 20,
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
        >
          /関連付け
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: "32px",
          "@media screen and (max-width:1200px)": {
            flexDirection: "column",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "fit-content",
            width: "100%",
            justifyContent: "center",
            borderRadius: 2,
            borderTop: 16,
            borderColor: "primary.main",
            boxShadow: 3,
            color: "outline.dark",
            backgroundColor: "#fff",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "fit-content",
              justifyContent: "center",
              padding: "16px 40px 32px 40px",
              gap: "40px",
              alignItems: "center",
              "@media screen and (max-width:600px)": {
                padding: "16px 16px 32px 16px",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "min-content",
                fontSize: 20,
                fontWeight: "bold",
                color: "primary.main",
                whiteSpace: "nowrap",
              }}
            >
              関連付け済み組織
            </Box>
            <ConnectedTable
              CheckedItems={setConnectedOrganizations}
              connectedOrganizations={connectedOrganizations}
              update={update}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "fit-content",
            width: "100%",
            justifyContent: "center",
            borderRadius: 2,
            borderTop: 16,
            borderColor: "primary.main",
            boxShadow: 3,
            color: "outline.dark",
            backgroundColor: "#fff",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "fit-content",
              justifyContent: "center",
              padding: "16px 40px 32px 40px",
              gap: "40px",
              alignItems: "center",
              "@media screen and (max-width:600px)": {
                padding: "16px 16px 32px 16px",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "144px",
                fontSize: 20,
                fontWeight: "bold",
                color: "primary.main",
                wordWrap: "break-word",
                maxWidth: "216px",
                textAlign: "center",
              }}
            >
              未関連組織
            </Box>
            <DisconnectedTable
              CheckedItems={setDisconnectedOrganizations}
              disconnectedOrganizations={disconnectedOrganizations}
              update={update}
            />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          position: "sticky",
          bottom: "16px",
        }}
      >
        <Fab
          name="registrationButton"
          variant="extended"
          color="primary"
          onClick={ClickRegistration}
          sx={{
            width: "144px",
          }}
        >
          登録
        </Fab>
      </Box>
      <SnackbarCustom
        data={snackBarstatus}
        openStatus={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
      />
    </>
  );
}
